<template>
  <v-container grid-list-md fluid pa-0>
    <v-layout wrap>
      <v-flex xs6>
        <v-text-field v-model="search.number" label="Номер" solo/>
      </v-flex>
      <v-flex xs6>
        <v-select :items="categories" v-model="sortedSelectedCategories" label="Категория" multiple solo
                  persistent-hint/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CategoryService from '@/services/CategoryService'

export default {
  props: {
    search: Object
  },
  data: () => ({
    categories: CategoryService.getList()
  }),
  computed: {
    sortedSelectedCategories: {
      get: function () {
        return this.search.category
      },
      set: function (value) {
        this.search.category = value.sort()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/fragments/Search.vue